window.printRecipe = function () {
  const summary = document.querySelector('.recipe-summary');
  const content = document.querySelector('.recipe-content');

  if (!summary || !content) {
    alert('Het recept kon niet worden klaargezet om te printen.');
    return;
  }

  const summaryCopy = summary.cloneNode(true);
  const contentCopy = content.cloneNode(true);

  const oldButton = summaryCopy.querySelector('.recipe-print-button');

  if (oldButton) {
    oldButton.remove();
  }

  const printWindow = window.open('', '_blank', 'width=1000,height=800');

  if (!printWindow) {
    alert('Sta pop-ups toe in je browser en probeer opnieuw.');
    return;
  }

  printWindow.document.open();

  printWindow.document.write(`
    <!doctype html>
    <html lang="nl">
      <head>
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1">
        <title>Recept - Baking Bread NL</title>

        <style>
          @page {
            size: A4;
            margin: 15mm;
          }

          * {
            box-sizing: border-box;
          }

          body {
            max-width: 900px;
            margin: 0 auto;
            padding: 30px;
            color: #222;
            background: #fff;
            font-family: Georgia, serif;
            font-size: 15px;
            line-height: 1.55;
          }

          h1 {
            margin: 0 0 5px;
            font-size: 34px;
          }

          h2 {
            margin-top: 0;
            font-size: 25px;
          }

          .print-action {
            display: block;
            margin: 0 0 30px auto;
            padding: 12px 20px;
            border: 0;
            border-radius: 30px;
            background: #4f555c;
            color: #fff;
            font: inherit;
            cursor: pointer;
          }

          .recipe-print-title {
            display: block;
            margin-bottom: 25px;
            padding-bottom: 15px;
            border-bottom: 1px solid #ccc;
          }

          .recipe-print-title p {
            margin: 0;
            font-size: 13px;
          }

          .recipe-summary__grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            margin-bottom: 35px;
            overflow: hidden;
            border: 1px solid #bbb;
          }

          .recipe-summary__item {
            display: flex;
            flex-direction: column;
            gap: 5px;
            padding: 12px;
            border-right: 1px solid #bbb;
            border-bottom: 1px solid #bbb;
          }

          .recipe-summary__item:nth-child(3n) {
            border-right: 0;
          }

          .recipe-summary__item:nth-last-child(-n + 3) {
            border-bottom: 0;
          }

          .recipe-summary__item span {
            color: #666;
            font-size: 13px;
          }

          .recipe-content__columns {
            display: grid;
            grid-template-columns: 35% 1fr;
            gap: 30px;
            align-items: start;
          }

          .recipe-ingredients,
          .recipe-tips {
            padding: 20px;
            border: 1px solid #bbb;
            background: #f5f5f2;
          }

          .recipe-richtext ul,
          .recipe-richtext ol {
            padding-left: 22px;
          }

          .recipe-richtext li {
            margin-bottom: 7px;
          }

          .recipe-tips {
            margin-top: 30px;
            border-left: 5px solid #4f555c;
          }

          .recipe-tips__label {
            font-size: 12px;
            font-weight: bold;
            letter-spacing: 1px;
            text-transform: uppercase;
          }

          @media print {
            body {
              max-width: none;
              padding: 0;
            }

            .print-action {
              display: none;
            }

            .recipe-summary__item,
            .recipe-ingredients,
            .recipe-tips {
              break-inside: avoid;
            }
          }
        </style>
      </head>

      <body>
        <button class="print-action" onclick="window.print()">
          Recept afdrukken
        </button>

        <main id="recipe-print-content"></main>
      </body>
    </html>
  `);

  printWindow.document.close();

  const printContent = printWindow.document.getElementById(
    'recipe-print-content'
  );

  printContent.appendChild(summaryCopy);
  printContent.appendChild(contentCopy);

  const recipeTitle = summaryCopy.querySelector('h1');

  if (recipeTitle) {
    printWindow.document.title =
      recipeTitle.textContent + ' - Baking Bread NL';
  }

  printWindow.focus();
};